import { Link, useLocation } from 'react-router'
import {
  LayoutDashboard,
  Circle,
  Users,
  Calendar,
  Link2,
  Settings,
  HelpCircle,
  Library,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  label: string
  href: string
  icon?: string
  isSeparator?: boolean
}

interface MainNavProps {
  items: NavItem[]
  isCollapsed: boolean
}

const iconMap: Record<string, LucideIcon> = {
  pipeline: LayoutDashboard,
  series: Library,
  recordings: Circle,
  guests: Users,
  schedule: Calendar,
  integrations: Link2,
  settings: Settings,
  help: HelpCircle,
}

export function MainNav({ items, isCollapsed }: MainNavProps) {
  const { pathname } = useLocation()

  return (
    <ul className="space-y-1 px-2">
      {items.map((item, index) => {
        if (item.isSeparator) {
          return (
            <li key={`sep-${index}`} className="my-4 border-t border-zinc-200 dark:border-zinc-800" />
          )
        }

        const Icon = item.icon ? iconMap[item.icon] || LayoutDashboard : LayoutDashboard
        const isActive = pathname === item.href || pathname.startsWith(`${item.href}/`)

        return (
          <li key={item.href}>
            <Link
              to={item.href}
              className={`
                w-full flex items-center gap-3 px-3 py-2 rounded-lg
                transition-colors duration-150
                ${isCollapsed ? 'justify-center' : ''}
                ${isActive
                  ? 'text-white bg-primary-500'
                  : 'text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 hover:bg-zinc-100 dark:hover:bg-zinc-800'
                }
              `}
              title={isCollapsed ? item.label : undefined}
            >
              <Icon className="w-5 h-5 flex-shrink-0" />
              {!isCollapsed && (
                <span className="text-sm font-medium">{item.label}</span>
              )}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
